import { useContext } from 'react';

import { SHeader } from 'app/components/StaycationUI';
import { HotelContext } from 'app/context/HotelContext/HotelContext';

import { ButtonAutoInventory } from '../../ExtranetInventory/_common/ButtonAutoInventory/ButtonAutoInventory';
import { WebsiteButton } from '../../ExtranetInventory/_common/WebsiteButton/WebsiteButton';
import { PackageButton } from '../../ExtranetPackages/Legacy/_components/PackageButton/PackageButton';
import { TaskCenterButton } from '../TaskCenter/Legacy/TaskCenterButton/TaskCenterButton';
import { ModernTaskCenterButton } from '../TaskCenter/Modern/ModernTaskCenterButton/ModernTaskCenterButton';

type ExtranetHeaderProps = {
  page: string;
  subTitle?: React.ReactNode;
  withWebsiteButton?: boolean;
  withAutoInventoryButton?: boolean;
  hasAutoInventoryActivated?: boolean;
  setIsAutoInventoryModalOpen?: (value: boolean) => void;
  withPackageButton?: boolean;
  packageSlug?: string;
  className?: string;
};

export const ExtranetHeader = ({
  page,
  subTitle,
  withWebsiteButton = false,
  withAutoInventoryButton = false,
  hasAutoInventoryActivated = false,
  setIsAutoInventoryModalOpen,
  withPackageButton = false,
  packageSlug = '',
  className = '',
}: ExtranetHeaderProps) => {
  const { hotelInfo } = useContext(HotelContext);

  return (
    <>
      <SHeader
        title={page}
        subtitle={subTitle}
        className={className}
        extra={[
          withPackageButton && (
            <PackageButton key={'package-button'} packageSlug={packageSlug} />
          ),
          withWebsiteButton && <WebsiteButton key={'website-button'} />,
          withAutoInventoryButton && setIsAutoInventoryModalOpen && (
            <ButtonAutoInventory
              key={'auto-inventory-button'}
              setIsAutoInventoryModalOpen={setIsAutoInventoryModalOpen}
              hasAutoInventoryActivated={hasAutoInventoryActivated}
            />
          ),
          hotelInfo?.isLegacy ? (
            <TaskCenterButton key={'task-center-button'} />
          ) : (
            <ModernTaskCenterButton key="task-center-button" />
          ),
        ]}
      />
    </>
  );
};
